import { LinkedContinents } from 'components/LinkedContinents';

// What the netplay page loaded as, while it is in the page area (the entry's
// activate enters it, its cleanup leaves). The layout used to print these as
// the isInLadder, matchOnlyMode and linkedContinents globals; legacy modules
// that branch on "am I on the netplay page" read them here instead. This is
// the one place that state lives (docs/site-session.md).
let page = null;

export function enterNetplayPage({ matchOnly = false, linkedContinents = {} } = {}) {
	page = {
		matchOnly: !!matchOnly,
		linkedContinents: new LinkedContinents(linkedContinents || {}),
	};
}

export function leaveNetplayPage() {
	page = null;
}

export function isNetplayPageActive() {
	return page !== null;
}

// The match popup (/netplay?match_only, or chat rooms turned off).
export function isMatchOnlyMode() {
	return page !== null && page.matchOnly;
}

export function netplayLinkedContinents() {
	return page ? page.linkedContinents : null;
}
